var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalenderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4151_31635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.642 1.6H11.8519V0H10.2716V1.6H3.95062V0H2.37037V1.6H1.58025C0.70321 1.6 0.00790123 2.32 0.00790123 3.2L0 14.4C0 15.28 0.70321 16 1.58025 16H12.642C13.5111 16 14.2222 15.28 14.2222 14.4V3.2C14.2222 2.32 13.5111 1.6 12.642 1.6ZM12.642 14.4H1.58025V5.6H12.642V14.4Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16016 7.2002H7.11077V11.2002H3.16016V7.2002Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4151_31635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 16,
    fill: "white"
  })))));
}

export default SvgCalenderIcon;